import { EMPLOYEE_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";
import { Filters } from "../hooks/useRwoTaskList";

// get dwo daily task by attendance id
export const getDailyTaskDwo = async (attendanceId: string) => {

  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.get(
    `/dwo-tracker/daily/attendance/${attendanceId}`,
  );

  return data.data.dwo_daily_trackers;
};

// get rwo daily task by attendance id
export const getDailyTaskRwo = async (attendanceId: string) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { data } = await api.get(
    `/rwo-tracker/daily/attendance/${attendanceId}`,
  );

  return data.data.rwo_daily_trackers;
};


// daily task submitted list rwo
export const getDailyTaskListRwo = async (filters: Filters) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { page, date } = filters;

  const params = new URLSearchParams();

  params.set("page", page.toString());

  if (date) params.set("date", date);

  const { data } = await api.get(`/rwo-tracker/list?pagesize=10&${params.toString()}`);

  return data.data;
};

// daily task submitted list dwo
export const getDailyTaskListDwo = async (filters: Filters) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { page, date } = filters;

  const params = new URLSearchParams();

  params.set("page", page.toString());

  if (date) params.set("date", date);

  const { data } = await api.get(`/dwo-tracker/list?pagesize=10&${params.toString()}`);

  return data.data;
};
